import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNativeLargeRectangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 35,
			height: 35,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 3.27295,
			width: 36,
			height: .818182,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 6,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 9.5,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 13,
			width: 13.3333,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 20,
			width: 13.3333,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 16.5,
			width: 13.3333,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 23.5,
			width: 13.3333,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 30.5,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 27,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19,
			y: 12.6367,
			width: 13.9996,
			height: 11.6663,
			rx: 1.02854,
			fill: "var(--format-icon-color, #A8F0F0)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			y: 20.6367,
			width: 8,
			height: 3,
			rx: 1,
			fill: "white"
		})
	]
});
export default SvgNativeLargeRectangle;
